// English translation

const en = {
  "production.production.draft": "Draft",
  "production.production.reserved": "Reserved",
  "production.production.in_execution": "In execution",
  "production.production.finished": "Finished",
};

export default en;
